import { render, staticRenderFns } from "./PartListAddNew.vue?vue&type=template&id=4b34b39f"
import script from "./PartListAddNew.vue?vue&type=script&lang=js"
export * from "./PartListAddNew.vue?vue&type=script&lang=js"
import style0 from "./PartListAddNew.vue?vue&type=style&index=0&id=4b34b39f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports